import { Home } from "../../components/backgrounds/Home";

const posts = [
  {
    title: "4 apps para llevar un registro financiero",
    href: "/blog/4-apps-para-llevar-un-registro-financiero",
    description:
      "En este blog te contamos qué apps puedes usar para que lleves las riendas de tu vida financiera. ",
    date: "Jul 12, 2022",
    datetime: "2020-02-12",
  },
  {
    title: "6 consejos para manejar tus finanzas",
    href: "/blog/6-consejos-para-manejar-tus-finanzas",
    description:
      "Si aún no sabes cómo debes organizar tus finanzas, aquí te contamos 6 consejos que puedes aplicar.",
    date: "Jun 22, 2022",
    datetime: "2020-02-12",
  },
  {
    title: "Cómo construir historial crediticio",
    href: "/blog/como-construir-historial-crediticio",
    description:
      "Tener un buen historial crediticio te permite obtener diferentes servicios con entidades financieras, por eso en este blog te contamos cómo puedes comenzar a construirlo.",
    date: "May 06, 2022",
    datetime: "2020-02-12",
  },
  {
    title: "¿Cómo aumentar mi cupo de crédito en Galilea?",
    href: "/blog/como-aumentar-mi-cupo-de-credito",
    description:
      "¿Te gustaría aumentar tu límite de crédito, pero aún no sabes cómo hacerlo? Hoy te contamos qué debes hacer para aumentar tu cupo en Galilea.",
    date: "Mar 16, 2022",
    datetime: "2020-03-16",
  },
  {
    title: "¿Cómo mejorar mi puntaje en Datacredito?",
    href: "/blog/como-mejorar-mi-puntaje-en-datacredito",
    description:
      "Necesitas aumentar tu puntaje de crédito, pero no sabes qué puedes hacer, tranquilo astronauta, en Galilea te contamos cómo.",
    date: "Mar 10, 2022",
    datetime: "2020-03-10",
  },
  {
    title: "¿Por qué Galilea negó mi solicitud?",
    href: "/blog/por-que-galilea-nego-mi-solicitud",
    description:
      "Hola astronauta, si tienes dudas sobre tu proceso de solicitud y no sabes porqué negamos un préstamo, aquí te contamos.",
    date: "Feb 12, 2022",
    datetime: "2020-02-12",
  },
];

export function IndexBlogPage() {
  return (
    <>
    <Home title={'Blog'} />
      <div className="bg-white pt-8 pb-20 px-4 sm:px-6 lg:pt-8 lg:pb-28 lg:px-8">
        <div className="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">
          <div className="mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12">
            {posts.map((post) => (
              <div key={post.title}>
                <p className="text-sm text-gray-500">
                  <time dateTime={post.datetime}>{post.date}</time>
                </p>
                <a href={post.href} className="mt-2 block">
                  <p className="text-xl font-semibold text-gray-900">
                    {post.title}
                  </p>
                  <p className="mt-3 text-base text-gray-500">
                    {post.description}
                  </p>
                </a>
                <div className="mt-3">
                  <a
                    href={post.href}
                    className="text-base font-semibold text-purple hover:text-purple/80"
                  >
                    Leer más
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
